import { create } from "zustand"

export const heatmapStore = create((set) => ({
  heatmaps: [],
  visualMax: 0,

  setChart: (heatmapData, visualMax) => {
    const heatmaps = Object.entries(heatmapData).map(([key, value]) => {
      const { x_labels, y_labels, data } = value
      const xLabels = x_labels.map((l) => l.slice(-5))
      return [key, { xLabels: xLabels, yLabels: y_labels, data }]
    })
    set({ heatmaps, visualMax })
  },

  reset: () => {
    set({
      heatmaps: [],
      visualMax: 0
    })
  }
}))
